import { render, staticRenderFns } from "./ClaimRemarksCard.vue?vue&type=template&id=3b22eb82&scoped=true&lang=pug&"
import script from "./ClaimRemarksCard.vue?vue&type=script&lang=js&"
export * from "./ClaimRemarksCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b22eb82",
  null
  
)

export default component.exports